var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"valueContainer",staticClass:"display-table-value"},[_vm._v(" "+_vm._s(this.displayValueText)+" "),(this.isLong)?_c('ToggleMoreButton',{on:{"onToggled":_vm.onMoreToggled}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }